
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Options, Vue, prop } from "vue-class-component";

class Props {
  flag = prop<string>({
    type: String,
    default: "",
  });
  regionName = prop<string>({
    type: String,
    default: "",
  });
  isStiDest = prop<boolean>({
    type: Boolean,
    default: false
  })
}

@Options({})
export default class RTSIcon extends Vue.with(Props) {
  get isAccountForeign() {
    return AccountController.accountData?.accountIsForeign
  }

  get rtsIconSrc() {
    return this.isAccountForeign
      ? require('@/app/ui/assets/svg/sti-reverse-scan/icon-rts-en.svg')
      : require('@/app/ui/assets/svg/sti-reverse-scan/icon-rts.svg')
  }
}
